module.exports = __webpack_public_path__ + "img/simulation-empty-state.63ff2d1c.svg";